module.exports = __webpack_public_path__ + "static/referenceimage-d8b35768e45c606b348e240fe34de06f.mp4";